import React, { useEffect, useState } from 'react';
import { Avatar, Box, Dialog, Grid, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import Carousel from '../features/Auth/components/Carousel';
import ForgotPasswordForm from '../features/Auth/components/ForgotPasswordForm';
import LoginForm from '../features/Auth/components/LoginForm';
import LinkwayLogo from '../assets/Linkway/LinkwayLogoText.png';
import LinkwayLogo2 from '../assets/Linkway/LinkwayLogoText2.png';
import GNXTLogo from '../assets/GatewayLogo/G_NXTLogo.png';

import GatewayLogo from '../assets/GatewayLogo/image.png';
import linkwaybg2 from '../assets/linkwaybg5.png';
import { Close, KeyboardDoubleArrowRight, KeyboardDoubleArrowRightOutlined, SkipNext } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const AuthPage = () => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showSplash, setShowSplash] = useState(false);
  const [animateSplash, setAnimateSplash] = useState(false);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const navigate = useNavigate();
  const isKeyboardOpen = useDetectKeyboardOpen();
  const handleFocus = () => {
    setIsKeyboardVisible(true);
  };

  const handleBlur = () => {
    setIsKeyboardVisible(false);
  };

  const handleSkip = () => {
    navigate('/public');
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setAnimateSplash(true);
  //   }, 500);

  //   const timer2 = setTimeout(() => {
  //     setShowSplash(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //     clearTimeout(timer2);
  //   };
  // }, []);

  const [openWebView, setOpenWebView] = useState(false);
  const [webViewUrl, setWebViewUrl] = useState('');

  const links = ['Privacy Policy', 'Terms of use'];
  const urls = {
    'Privacy Policy': 'https://thegatewaycorp.com/privacy-policy/',
    'Terms of use': 'https://thegatewaycorp.com/terms-of-use/',
  };
  const handleOpenWebView = (url) => {
    setWebViewUrl(url);
    setOpenWebView(true);
  };

  const handleCloseWebView = () => {
    setOpenWebView(false);
    setWebViewUrl('');
  };

  const LinkTypography = ({ text }) => (
    <Typography
      variant="body2"
      color="grey"
      sx={{
        cursor: 'default',
        '&:hover': { color: '#3366cc', textDecoration: 'underline' },
        fontSize: isSm ? '0.75rem' : '0.875rem',
      }}
      onClick={() => handleOpenWebView(urls[text])}
    >
      {text}
    </Typography>
  );

  const SplashScreen2 = () => (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      sx={{
        backgroundColor: '#FFFFFF',
        position: 'relative',
      }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        // sx={{ position: 'absolute', top: '35%' }}
      >
        <motion.div
          initial={{ translateY: 0, scale: 1 }}
          animate={{ translateY: animateSplash ? '-27.3vh' : '0vh', scale: animateSplash ? 0.797 : 1 }}
          // transition={{ duration: 0.7, ease: [0.68, -0.55, 0.27, 1.55] }}
        >
          {/* <Avatar
            variant='square'
            src={LinkwayLogo}
            alt='Linkway Logo'
            sx={{
              height: 150,
              width: 'auto',
              objectFit: 'contain',
            }}
          /> */}
          <img
            // variant='square'
            src={GNXTLogo}
            alt="Linkway Logo"
            style={{
              height: '150px',
              width: 'cover',
              // objectFit: 'contain',
            }}
          />
        </motion.div>
      </Grid>

      <Grid position="absolute" bottom={30} width="100%" display="flex" justifyContent="center" alignItems="center">
        <Typography sx={{ fontSize: '0.75rem' }}>Powered by</Typography>
        <Avatar
          variant="square"
          src={GatewayLogo}
          alt="Gateway Logo"
          sx={{
            ml: 1,
            borderRadius: 1,
            height: 45,
            width: 170,
          }}
        />
      </Grid>
    </Box>
  );

  return (
    <>
      {showSplash && isSmallScreen ? (
        <SplashScreen2 />
        // <p>Loading</p>
      ) : isSmallScreen ? (
        <Box
          sx={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'space-between',
          }}
        >
          <Box
            sx={{
              height: '30%',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
              // border: '1px solid black',
            }}
          >
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton
                onClick={handleSkip}
                sx={{
                  // position: 'absolute',
                  // top: isSm ? 20 : 20,
                  // right: isSm ? 5 : 20,
                  color: 'black',
                  borderRadius: '5px',
                  padding: '5px 10px',
                  fontSize: isSm ? '0.85rem' : '1rem',
                  '&:hover': {
                    backgroundColor: '#498dcb',
                  },
                  cursor: 'default',
                }}
              >
                Skip
                <KeyboardDoubleArrowRightOutlined color="black" fontSize={isSm ? 'small' : 'medium'} />
              </IconButton>
            </Box>
            <Grid
              container
              // position="absolute"
              // top={isKeyboardOpen ? '20px' : '60px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              // height={isKeyboardOpen ? '70px' : '120px'}
              // width={'80%'}
              // border={'1px solid red'}
            >
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={GNXTLogo}
                    alt="Linkway Logo"
                    style={{
                      borderRadius: 1,
                      height: isKeyboardOpen ? '60px' : '100px',
                      width: isKeyboardOpen ? 180 : 220,
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
            </Grid>
          </Box>
          <Box
            sx={{
              height: '60%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              // border: '1px solid blue',
            }}
          >
            <Box
              width={isSmallScreen ? '90%' : '35vw'}
              padding={isSmallScreen ? '1rem' : '2rem'}
              borderRadius="15px"
              display="flex"
              flexDirection="column"
              sx={{
                boxShadow: isSmallScreen ? 'none' : 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                backgroundColor: 'background.default',
                height: isSmallScreen ? 'auto' : 'auto',
                position: 'relative',
                overflow: 'hidden',
                border: isSmallScreen ? 0 : 0,
                borderRadius: isSmallScreen ? '8px' : 0,
                borderColor: isSmallScreen ? 'divider' : 'none',
              }}
            >
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
                position="relative"
              >
                <Stack
                  direction="column"
                  justifyContent="start"
                  alignItems="center"
                  width="100%"
                  height="100%"
                  sx={{ display: 'flex', flexDirection: 'column' }}
                >
                  {showForgotPassword ? (
                    <ForgotPasswordForm onSwitch={() => setShowForgotPassword(false)} />
                  ) : (
                    <LoginForm onFocus={handleFocus} onBlur={handleBlur} onSwitch={() => setShowForgotPassword(true)} />
                  )}
                </Stack>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              height: '10%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // border: '1px solid green',
            }}
          >
            <Grid
              // position="absolute"
              // bottom={isSm ? 30 : 20}
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography sx={{ fontSize: isSm ? '0.75rem' : '0.875rem' }}>Powered by</Typography>
              <Avatar
                variant="square"
                src={GatewayLogo}
                alt="Gateway Logo"
                sx={{
                  ml: 1,
                  borderRadius: 1,
                  height: 45,
                  width: 170,
                }}
              />
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          //      minHeight="100vh"
          sx={{
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {' '}
          <IconButton
            onClick={handleSkip}
            sx={{
              position: 'absolute',
              top: isSm ? 20 : 20,
              right: isSm ? 5 : 20,
              color: 'black',
              borderRadius: '5px',
              padding: '5px 10px',
              fontSize: isSm ? '0.85rem' : '1rem',
              '&:hover': {
                backgroundColor: '#498dcb',
              },
              cursor: 'default',
            }}
          >
            Skip
            <KeyboardDoubleArrowRightOutlined color="black" fontSize={isSm ? 'small' : 'medium'} />
          </IconButton>
          {isSm ? null : (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${linkwaybg2})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: isSmallScreen ? '' : 'center',
                zIndex: -1,
              }}
            />
          )}
          {isSmallScreen ? (
            <Grid
              container
              position="absolute"
              top={isKeyboardOpen ? '20px' : '60px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              height={isKeyboardOpen ? '70px' : '120px'}
              width={'80%'}
            >
              {/* <motion.div */}
              <div
                // initial={{
                //   top: 'calc(10vh)',
                //   left: '50%',
                //   translateX: '-50%',
                //   scale: 1,
                // }}
                // animate={{
                //   top: isKeyboardOpen ? '-10px' : 'calc(10vh)',
                //   left: isKeyboardOpen ? '-20%' : '50%',
                //   translateX: isKeyboardOpen ? '0%' : '-50%',
                //   scale: isKeyboardOpen ? 0.6 : 1,
                // }}
                // transition={{
                //   duration: 1,
                //   ease: 'easeInOut',
                // }}
                style={{
                  height: '100%',
                  width: '100%',
                  // position: 'absolute',
                  // top: isKeyboardOpen ? '-140px' : 'calc(10vh)',
                  // left: isKeyboardOpen ? '50%' : '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    // variant="square"
                    src={GNXTLogo}
                    alt="Linkway Logo"
                    style={{
                      borderRadius: 1,
                      height: isKeyboardOpen ? '60px' : '100px',
                      width: isKeyboardOpen ? 180 : 220,
                      objectFit: 'contain',
                    }}
                  />
                  {/* <Avatar
                  variant='square'
                  src={GNXTLogo}
                  alt='Linkway Logo'
                  style={{
                      borderRadius: 1,
                      height: isKeyboardOpen ? '80px':'100px',
                      width: isKeyboardOpen ? 100 : 180,
                      objectFit: 'contain',
                      }}
                      /> */}
                </div>
              </div>
              {/* </motiondiv> */}
            </Grid>
          ) : (
            <Grid container position="absolute" top={10} left={20}>
              <Avatar
                variant="square"
                src={GNXTLogo}
                alt="Linkway Logo"
                sx={{
                  borderRadius: 1,
                  height: 'auto',
                  width: 200,
                  objectFit: 'contain',
                }}
              />
            </Grid>
          )}
          <Box
            width={isSmallScreen ? '90%' : '35vw'}
            padding={isSmallScreen ? '1rem' : '2rem'}
            borderRadius="15px"
            display="flex"
            flexDirection="column"
            sx={{
              boxShadow: isSmallScreen ? 'none' : 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
              backgroundColor: 'background.default',
              height: isSmallScreen ? 'auto' : 'auto',
              position: 'relative',
              overflow: 'hidden',
              border: isSmallScreen ? 0 : 0,
              borderRadius: isSmallScreen ? '8px' : 0,
              borderColor: isSmallScreen ? 'divider' : 'none',
            }}
          >
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
              position="relative"
            >
              <Stack
                direction="column"
                justifyContent="start"
                alignItems="center"
                width="100%"
                height="100%"
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                {showForgotPassword ? (
                  <ForgotPasswordForm onSwitch={() => setShowForgotPassword(false)} />
                ) : (
                  <LoginForm onFocus={handleFocus} onBlur={handleBlur} onSwitch={() => setShowForgotPassword(true)} />
                )}
              </Stack>
            </Box>
          </Box>
          <Grid
            position="absolute"
            bottom={isSm ? 30 : 20}
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Typography sx={{ fontSize: isSm ? '0.75rem' : '0.875rem' }}>Powered by</Typography>
            <Avatar
              variant="square"
              src={GatewayLogo}
              alt="Gateway Logo"
              sx={{
                ml: 1,
                borderRadius: 1,
                height: 45,
                width: 170,
              }}
            />
          </Grid>
          {/* <Box position="absolute" bottom={isSm ? 10 : 20} right={isSm ? 0 : 20} width="100%" textAlign="center">
            <Box display="flex" justifyContent={isSm ? 'center' : 'right'} alignItems="center" gap={1}>
              {links.map((link, index) => (
                <React.Fragment key={link}>
                  <LinkTypography text={link} />
                  {index < links.length - 1 && (
                      <Typography variant="body2" color="grey">
                        |
                      </Typography>
                    )}
                  </React.Fragment>
                ))}
            </Box>
          </Box> */}
          <Dialog
            open={openWebView}
            onClose={handleCloseWebView}
            fullScreen
            sx={{
              '& .MuiDialog-paper': {
                margin: 0,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                borderRadius: 0,
                position: 'relative', // To position the close button
              },
            }}
          >
            {/* Web view content */}
            <Box
              sx={{
                height: '100vh',
                overflow: 'auto', // Hide scrollbars in the iframe container
              }}
            >
              <iframe
                src={webViewUrl}
                title="Web View"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  overflow: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  zIndex: 0,
                }}
              />
            </Box>
          </Dialog>
        </Box>
      )}
    </>
  );
};

export default AuthPage;
